<ng-container *ngIf="class$ | async as class">
    <vsc-public-event-card
        [publicEvent]="this.publicEvent$ | async"
        [orientation]="orientation"
        [verticalCardActionsTemplateRef]="verticalCardActionsTemplate"
        [horizontalCardActionsTemplateRef]="horizontalCardActionsTemplate"
        [isJoining]="isJoining"
        (click)="goToClassSessionDetailsPage(class.id, class.classSession?.id)"
        (keydown.enter)="
            goToClassSessionDetailsPage(class.id, class.classSession?.id)
        "
        (keydown.space)="
            $event.preventDefault();
            goToClassSessionDetailsPage(class.id, class.classSession?.id)
        "
        tabindex="0"
        [attr.aria-label]="
            'Open ' +
            (class?.name ?? 'Class') +
            (class?.isLiveStream ? ' (Live stream)' : '')
        "
    >
        <!-- Vertical card actions template -->
        <ng-template #verticalCardActionsTemplate>
            <ng-container
                *ngLet="
                    (isClassSessionReady$ | async) ===
                    true as isClassSessionReady
                "
            >
                <vsc-join-class
                    class="vertical-card-join"
                    #classroom
                    [classId]="class.id"
                    *ngIf="isClassSessionReady"
                    [isLiveStream]="class.isLiveStream"
                    [classSessionId]="class.classSession?.id"
                    [isZoomCreated]="class.isZoomEmbedded"
                    (keydown.enter)="$event.stopPropagation()"
                    (keydown.space)="
                        $event.stopPropagation(); $event.preventDefault()
                    "
                    (loadingChange)="isJoining = $event"
                >
                </vsc-join-class>

                <button
                    *ngIf="!isClassSessionReady && !class.isFavorite"
                    (click)="addToFavorite($event, class.id)"
                    (keydown.enter)="$event.stopPropagation()"
                    (keydown.space)="$event.stopPropagation()"
                    fxFlex
                    fxLayout="row"
                    fxLayoutAlign="center center"
                    class="btn-reset-style action-btn p-16 add-to-calendar-vertical"
                >
                    <vsc-icon icon="calendar-plus"></vsc-icon>
                    <span>{{ 'Add to my calendar' | transloco }}</span>
                </button>

                <button
                    *ngIf="!isClassSessionReady && class.isFavorite"
                    (click)="removeFromFavorite($event, class.id)"
                    (keydown.enter)="$event.stopPropagation()"
                    (keydown.space)="$event.stopPropagation()"
                    fxFlex
                    fxLayout="row"
                    fxLayoutAlign="center center"
                    class="btn-reset-style action-btn p-16 remove-from-calendar-vertical"
                    aria-label="Remove program from calendar"
                >
                    <vsc-icon icon="calendar-minus"></vsc-icon>
                    <span>
                        {{ 'Remove' | transloco }}
                    </span>
                </button>
            </ng-container>
        </ng-template>
        <!-- /Vertical card actions template -->

        <!-- Horizontal card actions template -->
        <ng-template #horizontalCardActionsTemplate>
            <ng-container
                *ngLet="
                    (isClassSessionReady$ | async) ===
                    true as isClassSessionReady
                "
            >
                <vsc-join-class
                    #classroom
                    [classSessionId]="class.classSession?.id"
                    *ngIf="isClassSessionReady"
                    [classId]="class.id"
                    [isLiveStream]="class.isLiveStream"
                    [isZoomCreated]="class.isZoomEmbedded"
                    (click)="$event.stopPropagation()"
                    (keydown.enter)="$event.stopPropagation()"
                    (keydown.space)="
                        $event.stopPropagation(); $event.preventDefault()
                    "
                    (loadingChange)="isJoining = $event"
                >
                </vsc-join-class>

                <button
                    *ngIf="!isClassSessionReady && !class.isFavorite"
                    (click)="addToFavorite($event, class.id)"
                    (keydown.enter)="$event.stopPropagation()"
                    (keydown.space)="$event.stopPropagation()"
                    class="btn-reset-style action-btn"
                    fxFlex
                    fxLayout="row"
                    fxLayoutAlign="center"
                >
                    <vsc-icon icon="calendar-plus"></vsc-icon>
                    <span class="add-to-calendar-horizontal">{{
                        'Add to my calendar' | transloco
                    }}</span>
                </button>

                <button
                    *ngIf="!isClassSessionReady && class.isFavorite"
                    (click)="removeFromFavorite($event, class.id)"
                    (keydown.enter)="$event.stopPropagation()"
                    (keydown.space)="$event.stopPropagation()"
                    class="btn-reset-style action-btn"
                    aria-label="Remove program from calendar"
                    fxFlex
                    fxLayout="row"
                    fxLayoutAlign="center"
                >
                    <vsc-icon icon="calendar-minus"></vsc-icon>
                    <span class="remove-from-calendar-horizontal">
                        {{ 'Remove' | transloco }}
                    </span>
                </button>
            </ng-container>
        </ng-template>
        <!-- /Horizontal card actions template -->
    </vsc-public-event-card>
</ng-container>
